import React, { useEffect, useState } from "react";
import { Dimensions, StyleSheet, View } from "react-native";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TextAlignTokens, } from "@voltmoney/schema";
import { SCREEN_SIZE } from '@voltmoney/types';
import { isMobile } from "../../stack/utils";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { addCommasToNumber } from "../utils";
const Repayment = ({ height, principalOutstandingAmount }) => {
    const [remainingTime, setRemainingTime] = useState(300);
    useEffect(() => {
        const timer = setInterval(() => {
            if (remainingTime > 0) {
                setRemainingTime(remainingTime - 1);
            }
        }, 1000);
        return () => clearInterval(timer);
    }, [remainingTime]);
    // Format the remaining time in MM:SS
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secondsLeft = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`;
    };
    // @ts-ignore
    return (React.createElement(View, { style: [
            styles.container,
            { height: height }
        ] },
        React.createElement(View, { style: {
                paddingHorizontal: 16,
                marginTop: 52,
                justifyContent: 'center',
                alignContent: 'center',
                alignSelf: 'center',
                alignItems: 'center'
            } },
            React.createElement(View, { style: {
                    width: 158,
                    height: 44,
                    backgroundColor: '#F1F3F5',
                    paddingVertical: 8,
                    paddingHorizontal: 16,
                    alignItems: 'center',
                    alignSelf: 'center',
                    alignContent: 'center',
                } },
                React.createElement(Typography, { fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, fontWeight: "700", lineHeight: 24, color: ColorTokens.Grey_Night, label: `Time left: ${formatTime(remainingTime)}`, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: {
                    marginTop: 24,
                    alignItems: 'center',
                    alignContent: 'center',
                    marginBottom: 8
                } },
                React.createElement(Typography, { fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins, fontWeight: "700", lineHeight: 24, color: ColorTokens.Grey_Night, label: "Nuvama Wealth has sent you a UPI payment request ", textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: {
                    alignItems: 'center',
                    alignContent: 'center',
                    marginBottom: 24
                } },
                React.createElement(Typography, { fontSize: FontSizeTokens.XL, fontFamily: FontFamilyTokens.Poppins, fontWeight: "700", lineHeight: 28, color: ColorTokens.Grey_Night, label: `Rs. ${addCommasToNumber(Number(principalOutstandingAmount))}`, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: {
                    width: 184,
                    height: 92,
                    alignContent: 'center',
                    alignItems: 'center',
                    alignSelf: 'center'
                } },
                React.createElement(Icon, { name: IconTokens.UpiInProgress, size: IconSizeTokens.XXXXXXXXL })),
            React.createElement(View, { style: {
                    marginTop: 24,
                    marginHorizontal: 24
                } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        marginBottom: 16
                    } },
                    React.createElement(View, { style: {
                            borderRadius: 18,
                            backgroundColor: '#F1F3F5',
                            width: 32,
                            height: 32,
                            justifyContent: 'center',
                            alignItems: 'center',
                            alignContent: 'center',
                            marginRight: 16
                        } },
                        React.createElement(Typography, { label: "1", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Night })),
                    React.createElement(View, { style: {
                            justifyContent: 'center',
                        } },
                        React.createElement(Typography, { label: 'Go to your UPI app', fontWeight: '400', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 }))),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        marginBottom: 16
                    } },
                    React.createElement(View, { style: {
                            borderRadius: 18,
                            backgroundColor: '#F1F3F5',
                            width: 32,
                            height: 32,
                            justifyContent: 'center',
                            alignItems: 'center',
                            alignContent: 'center',
                            marginRight: 16
                        } },
                        React.createElement(Typography, { label: "2", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Night })),
                    React.createElement(View, { style: {
                            justifyContent: 'center',
                        } },
                        React.createElement(Typography, { label: 'Accept payment request from Nuvama wealth', fontWeight: '400', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 }))),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        marginBottom: 16
                    } },
                    React.createElement(View, { style: {
                            borderRadius: 18,
                            backgroundColor: '#F1F3F5',
                            width: 32,
                            height: 32,
                            justifyContent: 'center',
                            alignItems: 'center',
                            alignContent: 'center',
                            marginRight: 16
                        } },
                        React.createElement(Typography, { label: "3", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Night })),
                    React.createElement(View, { style: {
                            justifyContent: 'center',
                        } },
                        React.createElement(Typography, { label: 'Complete payment & return to Volt Money', fontWeight: '400', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 }))))),
        React.createElement(View, { style: styles.netBankingCardBottom },
            React.createElement(Typography, { label: 'Do not leave at this step', fontSize: FontSizeTokens.XXS, fontFamily: FontFamilyTokens.Inter, lineHeight: 18, fontWeight: "400", color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height - 70 : Dimensions.get('window').height - 120,
        marginHorizontal: -16
    },
    bottomContainer: {
        position: 'absolute',
        bottom: 0,
        padding: 16,
        width: '100%',
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        borderColor: '#F2F4F7',
        borderTopWidth: 0.5,
        shadowOpacity: 0.08,
        elevation: 10,
        backgroundColor: 'white',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowRadius: 5,
    },
    securityView: { flexDirection: 'row', marginTop: 8 },
    netBankingCardContainer: {
        alignItems: "center", flex: 1, height: 260, padding: 16, alignContent: 'center'
    },
    netBankingCardLottie: { width: 70, height: 'auto' },
    netBankingCardTitle: { marginTop: 16 },
    netBankingCardDescription: { marginTop: 4 },
    netBankingCardBottom: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        backgroundColor: '#FFF6DD',
        alignContent: 'center',
        alignItems: 'center',
        height: 32,
        justifyContent: 'center',
    },
});
export default (Repayment);
